<style lang="scss" scoped>
@use '~@/styles/base/variables';

.settings-block {
  height: 200px;

  .title {
    font-size: 16px;
    color: var(--color-text-dark);
    font-weight: bold;
    border-bottom: 1px var(--color-border) solid;
    text-transform: uppercase;
    text-align: left;
    padding-bottom: 10px;
  }

  .table {
    border-collapse: collapse;
    width: 100%;

    &__section-name {
      color: var(--color-text-dark);
      font-size: 15px;
      padding-top: 30px;
      padding-bottom: 10px;
      padding-top: 10px;
      text-align: left;
    }

    &__row {
      font-size: 15px;
      height: 35px;

      td:nth-child(1) {
        width: 60%;
        text-align: left;
      }

      td:nth-child(2),
      td:nth-child(3) {
        width: 20%;
      }

      &_laptop-hide {
        @media screen and (max-width: variables.$medium - 1px) {
          display: none;
        }
      }
    }
  }
}

.theme {
  &__radio-icon {
    margin-bottom: 2px;
  }
}

.inl {
  display: inline-block;
}

.twoFaSecretCode {
  color: var(--color-info);
  font-size: 20px;
}

.names {
  font-size: 14px;
  color: var(--color-text-dark);
  font-weight: bold;
  vertical-align: bottom;
  border-bottom: 1px var(--color-border) solid;
  padding-bottom: 10px;
}
.settings-table {
  border-collapse: collapse;
  width: 100%;
}
.settings-table-row {
  background-color: var(--color-card-dark);
  font-size: 15px;
  height: 35px;
}
.settings-table-header {
  color: var(--color-text-dark);
  font-size: 15px;
  padding-top: 30px;
  padding-bottom: 10px;
}
.oddrow {
  background-color: var(--color-card);
}

div,
td {
  /*border: 1px white solid;*/
}

#settingsgrid {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(2, 1fr);
  padding-bottom: 10px;
}

@media all and (max-width: 1000px) {
  #settingsgrid {
    grid-template-columns: 1fr;
  }
}
</style>

<template>
  <div id="settingsgrid">
    <div
      id="changepwd"
      class="box symbbox"
      style="text-align: left; height: 100%"
    >
      <Button
        @click="resetPwd"
        size="large"
        type="primary"
      >{{
        $text.tr('СМЕНИТЬ ПАРОЛЬ')
      }}</Button>
      <br /><br />
      {{ pwdMsg }}
    </div>
    <div
      id="connecttg"
      class="box symbbox"
      style="
        text-align: left;
        min-width: 700px;
        min-height: 140px;
        height: 100%;
      "
    >
      <Button
        @click="connectTg"
        size="large"
        type="primary"
      >{{
        $text.tr('ПОДКЛЮЧИТЬ TELEGRAM УВЕДОМЛЕНИЯ')
      }}</Button>
      <br /><br />
      &nbsp;
      <div v-if="tgMsg">
        <span>{{ $text.tr('Добавьте') }}
          <span style="color: var(--color-info)">{{ botName }}</span>
          {{ $text.tr('и отправьте ему секретный код:') }}
        </span>
        <div style="display: flex; align-items: center">
          <Icon
            @click="$copyToClipboardAndNotify(tgMsg)"
            color="var(--color-text-dark)"
            style="cursor: pointer; margin-right: 5px"
            :title="$text.tr('Скопировать')"
            type="ios-copy-outline"
            size="24"
          ></Icon>
          <span style="color: var(--color-info)">{{ tgMsg }}</span>
        </div>
      </div>
    </div>
    <div
      id="notifysettings"
      class="box symbbox"
      style="text-align: left; height: 100%"
    >
      <table class="settings-table">
        <tr>
          <td
            class="names"
            style="width: 300px; font-size: 16px; padding-right: 5px"
          >
            {{ $text.tr('УВЕДОМЛЕНИЯ') }}
          </td>
          <td
            class="names"
            style="width: 100px; text-align: center; padding-right: 5px"
          >
            TELEGRAM
          </td>
          <td
            class="names"
            style="width: 100px; text-align: center; padding-right: 5px"
          >
            EMAIL
          </td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="settings-table-header"
            style="padding-top: 10px"
          >
            {{ $text.tr('ОБЩИЕ') }}
          </td>
        </tr>
        <template v-for="(item, index) in commonSettings">
          <tr
            :key="item.id"
            class="settings-table-row"
            :class="{ oddrow: index % 2 === 0 }"
          >
            <td>{{ $text.tr(item.text) }}</td>
            <td style="text-align: center">
              <Checkbox
                :value="setting(item.id).tg"
                @on-change="setSetting(item.id, 'tg', $event)"
              ></Checkbox>
            </td>
            <td style="text-align: center">
              <Checkbox
                :value="setting(item.id).email"
                @on-change="setSetting(item.id, 'email', $event)"
              ></Checkbox>
            </td>
          </tr>
        </template>
        <tr>
          <td
            colspan="3"
            class="settings-table-header"
          >
            {{ $text.tr('СДЕЛКИ') }}
          </td>
        </tr>
        <template v-for="(item, index) in tradeSettings">
          <tr
            :key="item.id"
            class="settings-table-row"
            :class="{ oddrow: index % 2 === 0 }"
          >
            <td>{{ $text.tr(item.text) }}</td>
            <td style="text-align: center">
              <Checkbox
                :value="setting(item.id).tg"
                @on-change="setSetting(item.id, 'tg', $event)"
              ></Checkbox>
            </td>
            <td style="text-align: center">
              <Checkbox
                :value="setting(item.id).email"
                @on-change="setSetting(item.id, 'email', $event)"
              ></Checkbox>
            </td>
          </tr>
        </template>
        <tr>
          <td
            colspan="3"
            class="settings-table-header"
          >
            {{ $text.tr('БОТЫ') }}
          </td>
        </tr>
        <template v-for="(item, index) in botSettings">
          <tr
            :key="item.id"
            class="settings-table-row"
            :class="{ oddrow: index % 2 === 0 }"
          >
            <td>{{ $text.tr(item.text) }}</td>
            <td style="text-align: center">
              <Checkbox
                :value="setting(item.id).tg"
                @on-change="setSetting(item.id, 'tg', $event)"
              ></Checkbox>
            </td>
            <td style="text-align: center">
              <Checkbox
                :value="setting(item.id).email"
                @on-change="setSetting(item.id, 'email', $event)"
              ></Checkbox>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <div
      id="2fa"
      class="box symbbox"
      style="text-align: left; min-height: 320px; height: 100%"
    >
      <tr style="vertical-align: top">
        <td style="width: 150px">
          <Button
            v-if="twofastatus === ''"
            @click="enable2fa"
            size="large"
            type="primary"
          >{{ $text.tr('ВКЛЮЧИТЬ 2FA') }}</Button>
          <Button
            v-else-if="
              twofastatus === 'disable' ||
                twofastatus === 'setup' ||
                twofastatus === 'wrongcode'
            "
            @click="cancel2fa"
            size="large"
            type="primary"
          >{{ $text.tr('ОТМЕНА') }}</Button>
          <Button
            v-else
            @click="disable2fa"
            size="large"
            type="primary"
          >{{
            $text.tr('ОТКЛЮЧИТЬ 2FA')
          }}</Button>
        </td>
        <td
          v-if="show2fa && twofastatus === 'setup'"
          style="width: 300px; text-align: center"
        >
          <p class="twoFaSecretCode">{{ twofasecret }}</p>
          <qrcode
            :value="twofaurl"
            :options="{
              width: 240,
              color: { light: '#ffffff', dark: '#000000' }
            }"
          />
        </td>
        <td
          v-if="show2fa"
          style="width: 300px"
        >
          <p v-if="show2fa && twofastatus === 'setup'">
            {{ $text.tr('Сохраните') }}
            <span style="color: var(--color-info)">{{
              $text.tr('секретный ключ')
            }}</span>
            {{
              $text.tr(
                'в безопасном месте. Он потребуется, если будет необходимо восстановить доступ к вашей учетной записи'
              )
            }}
          </p>
          <p
            v-if="show2fa && twofastatus === 'setup'"
            style="margin-top: 20px"
          >
            {{
              $text.tr(
                'Установите на свой телефон приложение Google Authenticator и с помощью него отсканируйте QR код'
              )
            }}
          </p>
          <p v-if="show2fa && twofastatus === 'disable'">
            <span style="color: var(--color-danger-light)">{{ $text.tr('Важно:') }}</span>
            {{
              $text.tr(
                'мы настоятельно не рекомендуем отключать двухфакторную аутентификацию, т.к. это существенно снижает степень защиты вашей учетной записи.'
              )
            }}
          </p>
          <p
            v-if="show2fa && twofastatus === 'disable'"
            style="padding-top: 20px"
          >
            {{ $text.tr('Для отключения введите код Google Authenticator') }}
          </p>
          <br v-if="
              (show2fa && twofastatus === 'disable') ||
                (show2fa && twofastatus === 'setup')
            " />
          <!--          <span v-if="twofastatus === 'success'" class="ggreen">2FA включена</span>-->
          <span
            v-if="show2faerr"
            class="gred"
          >{{
            $text.tr('Неверный код')
          }}</span>
          <br v-if="
              (show2fa && twofastatus === 'disable') ||
                (show2fa && twofastatus === 'setup')
            " />
          <i-input
            v-if="
              (show2fa && twofastatus === 'disable') ||
                (show2fa && twofastatus === 'setup')
            "
            style="width: 120px; font-size: 18px"
            :placeholder="$text.tr('Код 2FA')"
            size="large"
            v-model="twofacode"
            :disabled="twofacode.length > 5"
          ></i-input>
        </td>
      </tr>
    </div>
    <div class="settings-block box symbbox">
      <div class="title">{{ $text.tr('ПРОДВИНУТАЯ ТОРГОВЛЯ') }}</div>
      <table class="table">
        <tr>
          <td
            colspan="3"
            class="table__section-name"
          >
            {{ $text.tr('ТЕРМИНАЛ') }}
          </td>
        </tr>
        <tr class="table__row table__row_laptop-hide">
          <td>{{ $text.tr('Режим конструктора') }}</td>
          <td>
            <i-switch
              v-model="$store.state.sys.isConstructorModeAllowed"
              @on-change="
                saveSettingsMode('isConstructorModeAllowed', $event)
                $router.go(0)
              "
            >
              <Icon
                type="md-checkmark"
                slot="open"
              ></Icon>
              <Icon
                type="md-close"
                slot="close"
              ></Icon>
            </i-switch>
          </td>
          <td></td>
        </tr>
        <tr class="table__row">
          <td>
            {{ $text.tr('Без подтверждений') }}
            <Tooltip
                placement="right"
                max-width="240"
                :delay="500"
            >
              <Icon
                  style="margin-top: -5px;"
                  size="18"
                  type="ios-information-circle-outline"
                  color="var(--color-text-dark)"
              />
              <div slot="content" style="color: var(--color-warning)">
                {{ $text.tr('Внимание: данная настройка активирует функцию создания и отмены сделок в один клик. Увеличивается скорость работы, но при этом повышается риск ошибки от случайного нажатия.') }}
              </div>
            </Tooltip>
          </td>
          <td>
            <i-switch
              v-model="$store.state.sys.isNoConfirmationMode"
              @on-change="saveSettingsMode('isNoConfirmationMode', $event)"
            >
              <Icon
                type="md-checkmark"
                slot="open"
              ></Icon>
              <Icon
                type="md-close"
                slot="close"
              ></Icon>
            </i-switch>
          </td>
          <td></td>
        </tr>
      </table>
    </div>
    <div class="settings-block box symbbox">
      <div class="title">{{ $text.tr('ИНТЕРФЕЙС') }}</div>
      <table class="table">
        <tr>
          <td
            colspan="3"
            class="table__section-name"
          >
            {{ $text.tr('ОБЩИЕ') }}
          </td>
        </tr>
        <tr class="table__row">
          <td>{{ $text.tr('Тема') }}</td>
          <td style="min-width: 320px;">
            <RadioGroup
              v-model="currentTheme"
              type="button"
              size="large"
              class="theme"
            >
              <Radio label="default">
                <Icon
                  class="theme__radio-icon"
                  type="md-star"
                ></Icon>
                <span>default</span>
              </Radio>
              <Radio label="light">
                <Icon
                  class="theme__radio-icon"
                  type="md-sunny"
                ></Icon>
                <span>light</span>
              </Radio>
              <Radio label="dark">
                <span>dark</span>
                <Icon
                  class="theme__radio-icon"
                  type="md-moon"
                ></Icon>
              </Radio>
            </RadioGroup>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Api from '@/util/api'
import { sha256 } from 'js-sha256'

export default {
  name: 'Settings',
  data: function () {
    return {
      commonSettings: [
        {
          id: 'partfilled',
          text: 'Ордер частично исполнен'
        },
        {
          id: 'sltimeout',
          text: 'SL timeout'
        },
        {
          id: 'bottrigger',
          text: 'Cработал триггер'
        }
      ],
      tradeSettings: [
        {
          id: 'ordexe',
          text: 'Ордер исполнен'
        },
        {
          id: 'sltpexe',
          text: 'Сделка закрыта по SL/TP'
        },
        {
          id: 'panicexe',
          text: 'Продажа в панике'
        },
        {
          id: 'tptrailact',
          text: 'Trailing активирован'
        }
      ],
      botSettings: [
        {
          id: 'botstarted',
          text: 'Бот запущен'
        },
        {
          id: 'botordexe',
          text: 'Остальные сообщения бота'
        }
      ],
      tgMsg: '',
      pwdMsg: this.$text.tr(
        'На ваш email будет отправлено письмо с инструкцией'
      ),
      settingsData: {
        ordexe: {
          tg: false,
          email: false
        }
      },
      show2fa: false,
      twofaurl: '',
      twofasecret: '',
      twofacode: '',
      twofastatus: '',
      show2faerr: false,
      botName: '@CapicoBot'
    }
  },
  watch: {
    $route (to, from) {
      // console.log(to)
      if (to.name === 'settings') {
        this.updateSettings()
      }
    },
    twofacode (code) {
      if (code.length > 5) {
        if (this.twofastatus === 'setup') {
          this.confirm2fa()
        } else if (this.twofastatus === 'disable') {
          this.confirmDisable2fa()
        }
      }
    },
    twofastatus (status) {
      if (status === 'success') {
        this.$Message.info(
          this.$text.tr('Двухфакторная аутентификация включена')
        )
      }
    }
  },
  mounted () {
    if (process.env.VUE_APP_BASE_URL.includes('titan')) {
      this.botName = '@CapicoDevBot'
    }
    this.updateSettings()
  },
  async created () {
    await this.update2faStatus()
  },
  computed: {
    currentTheme: {
      get () {
        return this.$store.state.sys.theme
      },
      set (value) {
        localStorage.setItem('isTerminalThemeChanged', true)
        localStorage.setItem('isBotsThemeChanged', true)
        localStorage.setItem('isBoosterThemeChanged', true)
        localStorage.setItem('theme', value)
        this.$store.state.sys.theme = value
        document.documentElement.classList = ''
        document.documentElement.classList.add(value)
        this.$router.go(0)
      }
    }
  },
  methods: {
    saveSettingsMode (propName, value) {
      localStorage.setItem(propName, value)
    },
    async update2faStatus () {
      const promise = Api.get('user/2fa', {
        params: {
          token: this.$store.state.sys.token,
          action: 'status'
        }
      })
        .then(response => {
          // console.log(response.data)
          if (response.data.status === 'enabled') {
            this.twofastatus = 'enabled'
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      await promise
    },
    clear2fa () {
      this.show2fa = false
      this.twofacode = ''
      this.twofasecret = ''
      this.twofaurl = ''
      if (this.twofastatus === 'setup') {
        this.twofastatus = ''
      } else {
        this.twofastatus = 'enabled'
      }
    },
    confirm2fa () {
      Api.get('user/2fa', {
        params: {
          token: this.$store.state.sys.token,
          action: 'confirm',
          secret: this.twofasecret,
          code: this.twofacode
        }
      })
        .then(response => {
          if (response.data.err) {
            this.showWrongCode(response, 'setup')
          } else {
            this.twofastatus = 'success'
            setTimeout(() => {
              this.show2fa = false
              this.twofastatus = 'enabled'
              this.twofacode = ''
              this.twofaurl = ''
            }, 5000)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showWrongCode (response, status) {
      if (response.data.err) {
        this.show2faerr = true
        setTimeout(() => {
          this.twofastatus = status
          this.twofacode = ''
          this.show2faerr = false
        }, 3000)
      }
    },
    disable2fa () {
      this.twofastatus = 'disable'
      this.show2fa = true
    },
    confirmDisable2fa () {
      Api.get('user/2fa', {
        params: {
          token: this.$store.state.sys.token,
          action: 'disable',
          code: this.twofacode
        }
      })
        .then(response => {
          if (response.data.err === 'wrong code') {
            this.showWrongCode(response, 'disable')
          } else {
            this.clear2fa()
            this.twofastatus = ''
            this.$Message.info(
              this.$text.tr('Двухфакторная аутентификация отключена')
            )
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    cancel2fa () {
      this.clear2fa()
    },
    enable2fa () {
      Api.get('user/2fa', {
        params: {
          token: this.$store.state.sys.token,
          action: 'enable'
        }
      })
        .then(response => {
          // console.log(response.data)
          this.twofaurl = response.data.url
          this.twofasecret = response.data.secret
          this.twofastatus = 'setup'
          this.show2fa = true
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    setSetting (id, ch, val) {
      Api.get('settings/notify/set', {
        params: {
          token: this.$store.state.sys.token,
          name: id,
          ch,
          state: val
        }
      })
        .then(response => {
          // console.log(response.data)
          this.updateSettings()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    updateSettings () {
      Api.get('settings/notify/get', {
        params: {
          token: this.$store.state.sys.token
        }
      })
        .then(response => {
          // console.log(response.data)
          this.settingsData = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    setting (id) {
      if (this.settingsData[id]) {
        return this.settingsData[id]
      } else {
        return {}
      }
    },
    connectTg () {
      this.tgMsg = this.$store.state.sys.token
      const ref = this
      setTimeout(function () {
        ref.tgMsg = ''
      }, 60000)
    },
    resetPwd () {
      const x = sha256('V1c5QraZkYkA' + this.$store.state.sys.email.trim().toLowerCase()).substr(0, 6)
      const ref = this
      Api.get('forgotpwd', {
        params: {
          email: this.$store.state.sys.email,
          x
        }
      })
        .then(response => {
          ref.pwdMsg = ref.$text.tr('Письмо отправлено')
          setTimeout(function () {
            ref.pwdMsg = ref.$text.tr(
              'На ваш email будет отправлено письмо с инструкцией'
            )
          }, 10000)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
